import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";

import Intro from "./../Components/Intro";
import DividerTitle from "./../Components/DividerTitle";
import ProjectItem from "./../Components/ProjectItem";

const useStyles = makeStyles((theme: Theme) => ({
  palette: {
    type: "light",
  },
  content: {
    maxWidth: "9in",
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "32px",
  },
}));


export default function Home() {
  const classes = useStyles();

  return (
    <div className={classes.content}>
      <Intro />

      <DividerTitle title={"Recent Projects"} />

      <ProjectItem
        title="Base Weight"
        color="#DFF0EA"
        description="Application to keep track of your travels."
        imgPath="/assets/bw/feature.png"
        direction={0}
        tags={["In progress"]}
        path='baseweight'
      />

      <ProjectItem
        title="Relier"
        color="#D1F1FF"
        description="Stay engaged during video conferences."
        imgPath="/assets/relier/feature.png"
        direction={1}
        tags={["UX", "Design"]}
        path='relier'
      />
    </div>
  );
}
